module.exports = __webpack_public_path__ + "static/media/my-contact-info-photo.8fd05bcb.jpg";